import { jsx } from 'react/jsx-runtime';
import { useNpawAdapter, useNpawAdsAdapter } from '@dtvgo/npaw-context';

function withContexts(Component) {
  return function WithPlayerState(props) {
    const npawAdapter = useNpawAdapter();
    const npawAdsAdapter = useNpawAdsAdapter();
    return /* @__PURE__ */ jsx(Component, { ...props, adapter: npawAdapter, adsAdapter: npawAdsAdapter });
  };
}

export { withContexts as default };
//# sourceMappingURL=withContexts.hoc.js.map
